import store from '@/store/index';
import config from '@/utils/im/config.js';
import {
  Local
} from '@/utils/local.js';
import {
  startWebSocket
} from '@/utils/socket.js';
import {
  DELOP_generateUUID,
  setCookie,
  getCookie
} from '@/utils/md5';
import { setCatchingCurrSessionMsgs } from "@/utils/im/validate.js";

export default {
  IS_CONNECT_SOCKET(state, payload) {
    if (state.tell) {
      if (payload.visitSign) {
        state.visitSign = payload.visitSign;
        state.visitName = payload.visitName;
      }
      if (!state.groupConversationId) {
        const names = 'DELOP_link_' + state.childChannelId;
        let delopUUID = '';
        if (getCookie(names)) {
          delopUUID = getCookie(names);
        } else {
          delopUUID = DELOP_generateUUID();
          setCookie(names, delopUUID);
        }
        state.groupConversationId = delopUUID;
      }
      startWebSocket({
        companyId: state.companyId,
        groupConversationId: state.groupConversationId,
        childChannelId: state.childChannelId,
        conversationId: payload.id,
        yunduoId: payload.yunduoId,
        webtype: state.webtype,
        visitSign: state.visitSign,
        visitName: state.visitName,
        xst: state.xst,
        CT: state.CT,
        CH: state.CH,
        SR: state.SR
      })
    } else {
      window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
        type: 'getChatParams',
        payload: {
          id: payload.id,
          flag: payload.flag
        }
      }), '*')
    }
  },
  //设置聊天窗口配置信息
  SET_CHAT_CONFIG(state, obj) {
    if (obj[9] && obj[9].value) {
      state.chatConfig.type = obj[9].value;
    }
    if (obj[10] && obj[10].value) {
      state.chatConfig.color = obj[10].value
    }
    if (obj[12] && obj[12].value) {
      state.chatConfig.placeholder = obj[12].value
    }
    if (obj[13] && obj[13].value) {
      state.chatConfig.rightVisibile = obj[13].enableFlag;
      state.chatConfig.rightText = {
        type: '4',
        ...obj[13].value
      };
    }
    if (obj[40] && obj[40].value) {
      state.chatConfig.manualFlag = obj[40].value.flag ? obj[40].value.manualFlag : false;
    }
    if (obj[50] && obj[50].value) {
      // 聊天窗口顶部图片
      state.chatConfig.topImgVisibile = obj[50].enableFlag
      state.chatConfig.topImg = obj[50].value
      console.log('聊天窗口顶部图片', state.chatConfig)
      console.log('SET_CHAT_CONFIG', obj)
    }
    if (obj[51] && obj[51].value) {
      // 聊天窗口顶部图片
      state.chatConfig.logoImgVisibile = obj[51].enableFlag
      state.chatConfig.logoData = JSON.parse(obj[51].value)
      console.log('自定义LOGO', state.chatConfig.logoData)
      console.log('SET_CHAT_CONFIG', obj)
    }
    if (obj[61] && obj[61].value) {
      // 聊天窗口顶部图片
      state.chatConfig.tipsVisible = obj[61].enableFlag
    }
    if (obj[62] && obj[62].value) {
      // 聊天窗口顶部图片
      state.chatConfig.tipsSelfVisible = obj[62].enableFlag
      state.chatConfig.tipsSelfContent = obj[62].value
    }
    // if (document.getElementById('chatPageView')) {
    //   document.getElementById('chatPageView').style.setProperty('--chatThemeColor', state.chatConfig.color);
    // }
  },
  UPDATE_SESSIONS(state, sessions) {
    const nim = state.nim;
    console.log(nim)
    state.sessionList = nim.mergeSessions(state.sessionList, sessions)
    state.sessionList = state.sessionList.filter(item => {
      if (!item.lastMsg) {
        return false;
      }
      return true;
    });
    state.sessionList.sort((a, b) => {
      return b.updateTime - a.updateTime;
    });
    state.sessionList.forEach(item => {
      state.sessionMap[item.id] = item;
    });
    // console.log('UPDATE_SESSIONS---sessionList', state.sessionList);
    // console.log('UPDATE_SESSIONS---sessionMap', state.sessionMap);

    // // 如过没有当前对话，默认设置成第一个
    // if (!state.currSessionId) {
    //   store.commit('UPDATE_CURR_SESSION', state.sessionList[0]);
    // }
    // 更新名片信息
    store.commit('UPDATE_SESSIONS_INFO');
  },
  // 更新当前会话id
  UPDATE_CURR_SESSION_ID(state, currSessionId) {
    state.currSessionId = currSessionId;
    if (state.sessionMap[currSessionId]) {
      store.commit('UPDATE_CURR_SESSION', state.sessionMap[currSessionId]);
    } else {
      store.commit('UPDATE_CURR_SESSION', {});
    }
    if (!currSessionId) {
      // sessionStorage.removeItem('customerServiceId_' + state.childChannelId);
      store.commit('UPDATE_CUSTOMER_SERVICE_ID', '');
    }
    // 切换会话时需要重新获取conversationId
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`;
    let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
    if (conversationId) {
      store.commit('UPDATE_CONVERSATION_ID', conversationId);
    }
    console.log('UPDATE_CURR_SESSION_ID---currSessionId', currSessionId);
  },
  //
  UPDATE_CUSTOMER_SERVICE_ID(state, customerServiceId) {
    state.customerServiceId = customerServiceId;
    console.log('UPDATE_CUSTOMER_SERVICE_ID---customerServiceId', customerServiceId);
  },
  // 更新当前会话
  UPDATE_CURR_SESSION(state, currSession) {
    state.currSession = currSession;
    // store.commit('UPDATE_CURR_SESSION_ID', currSession.id);
    console.log('UPDATE_CURR_SESSION---currSession', currSession);
    console.log('UPDATE_CURR_SESSION---state', state);
  },
  // 更新会话列表的名片信息
  UPDATE_USER_INFO(state, users) {
    let sessionUserMap = state.sessionUserMap;
    users.forEach(user => {
      let account = user.account;
      if (account) {
        sessionUserMap[account] = Object.assign({}, sessionUserMap[account], user);
      }
    })
    state.sessionUserMap = Object.assign({}, state.sessionUserMap, sessionUserMap);
    store.commit('UPDATE_SESSIONS_INFO');
  },
  // 更新会话列表的更多属性
  UPDATE_SESSIONS_INFO(state) {
    // 如果有对应的名片，更新名片信息
    let newSessionList = [];
    state.sessionList.forEach((item) => {
      if (/^p2p-/.test(item.id)) {
        let account = item.id.replace(/^p2p-/, '');
        let user = state.sessionUserMap[account];
        let newItem = null;
        newItem = user ? Object.assign({}, item, user) : item;
        state.sessionUserMap[item.to] = newItem;
        newSessionList.push(newItem);

        if (state.currSessionId == item.id) {
          store.commit('UPDATE_CURR_SESSION', newItem);
        }
      }
    });
    state.sessionList = newSessionList;
    // console.log('UPDATE_SESSIONS_INFO---state.sessionList', state.sessionList);
  },
  // 更新当前会话列表的聊天记录，包括历史消息、单聊消息等，不包括聊天室消息
  // replace: 替换idClient的消息
  UPDATE_CURR_SESSION_MSGS(state, obj) {
    let type = obj.type || ''
    if (type === 'clear') { // 清空会话消息
      state.currSessionMsgs = []
      state.currSessionLastMsg = null
    }
    if (type === 'destroy') { // 清空会话消息
      state.currSessionMsgs = []
      state.currSessionLastMsg = null
      // store.commit('updateCurrSessionId', {
      //   type: 'destroy'
      // })
    } else if (type === 'init') { // 初始化会话消息列表
      if (state.currSessionId) {
        let sessionId = state.currSessionId;
        let currSessionMsgs = [].concat(state.msgs[sessionId] || [])
        // 做消息截断
        let limit = config.localMsglimit
        let msgLen = currSessionMsgs.length
        if (msgLen - limit > 0) {
          state.currSessionLastMsg = currSessionMsgs[msgLen - limit]
          currSessionMsgs = currSessionMsgs.slice(msgLen - limit, msgLen)
        } else if (msgLen > 0) {
          state.currSessionLastMsg = currSessionMsgs[0]
        } else {
          state.currSessionLastMsg = null
        }
        state.currSessionMsgs = []
        let lastMsgTime = 0
        currSessionMsgs.forEach(msg => {
          // if ((msg.time - lastMsgTime) > 1000 * 60 * 5) {
          //   lastMsgTime = msg.time
          //   state.currSessionMsgs.push({
          //     type: 'timeTag',
          //     text: util.formatDate(msg.time, false)
          //   })
          // }
          state.currSessionMsgs.push(msg)
        });
      }
    } else if (type === 'put') { // 追加一条消息
      let newMsg = obj.msg
      let lastMsgTime = 0
      let lenCurrMsgs = state.currSessionMsgs.length
      if (lenCurrMsgs > 0) {
        lastMsgTime = state.currSessionMsgs[lenCurrMsgs - 1].time
      }
      if (newMsg) {
        // 老逻辑
        // if ((newMsg.time - lastMsgTime) > 1000 * 60 * 5) {
        //   state.currSessionMsgs.push({
        //     type: 'timeTag',
        //     text: util.formatDate(newMsg.time, false)
        //   })
        // }

        // 处理词槽数据
        let currSessionMsgs = setCatchingCurrSessionMsgs(state.currSessionMsgs, newMsg, this);

        console.log("currSessionMsgs ======>", currSessionMsgs, obj);

        state.currSessionMsgs.push(newMsg);
        state.currSessionLastMsg = newMsg;
      }
    } else if (type === 'concat') {
      // 一般用于历史消息拼接
      let currSessionMsgs = []
      let lastMsgTime = 0
      obj.msgs.forEach(msg => {
        // if ((msg.time - lastMsgTime) > 1000 * 60 * 5) {
        //   lastMsgTime = msg.time
        //   currSessionMsgs.push({
        //     type: 'timeTag',
        //     text: util.formatDate(msg.time, false)
        //   })
        // }
        // currSessionMsgs.push(msg)

        // 增加判断防止消息重复
        const existItem = state.currSessionMsgs.find((item) => {
          return item.idClient == msg.idClient
        })
        if(!existItem) {
          currSessionMsgs.push(msg)
        }
      })
      currSessionMsgs.reverse()
      currSessionMsgs.forEach(msg => {
        state.currSessionMsgs.unshift(msg)
      })
      if (obj.msgs[0]) {
        state.currSessionLastMsg = obj.msgs[0]
      }
    } else if (type === 'replace') {
      let msgLen = state.currSessionMsgs.length
      let lastMsgIndex = msgLen - 1
      if (msgLen > 0) {
        for (let i = lastMsgIndex; i >= 0; i--) {
          if (state.currSessionMsgs[i].idClient === obj.idClient) {
            state.currSessionMsgs.splice(i, 1, obj.msg)
            break
          }
        }
        // console.log('-------历史消息', state.currSessionMsgs)
        // const topMsg = Object.assign({}, obj.msg, {
        //   custom: "{\"type\": 2, \"from\" : \"robot\"}",
        //   content: JSON.stringify({
        //     msg: state.chatConfig.topImg
        //   })})
        // state.currSessionMsgs.unshift(topMsg)
      }
    } else if (type === 'delete') {
      let msgLen = state.currSessionMsgs.length
      let lastMsgIndex = msgLen - 1
      if (msgLen > 0) {
        for (let i = lastMsgIndex; i >= 0; i--) {
          if (state.currSessionMsgs[i].idClient === obj.idClient) {
            state.currSessionMsgs.splice(i, 1)
            break
          }
        }
      }
    }

    store.dispatch('setLoading', false);

    console.log('state.currSessionMsgs', state.currSessionMsgs);
  },
  UPDATE_VISITOR_FIRST_FLAG_MAP(state, firstFlag) {
    console.log('UPDATE_VISITOR_FIRST_FLAG_MAP---state', state);
    if (state.currSessionId) {
      state.visitorFirstFlagMap[state.currSessionId] = firstFlag;
      console.log('UPDATE_VISITOR_FIRST_FLAG_MAP---', firstFlag);
      // Local.set(`visitorFirstFlagMap_${state.childChannelId}_${state.groupConversationId}`, JSON.stringify(state.visitorFirstFlagMap));
    }
  },
  // 收到的撤回消息处理
  ON_REVOCATE_MSG(state, sysMsg) {
    let msg = sysMsg.msg;
    let idClient = sysMsg.deletedIdClient || msg.idClient;
    let sessionId = msg.sessionId;
    store.commit('REPLACE_MSG', {
      sessionId: msg.sessionId,
      idClient,
      msg
    });
    if (msg.sessionId === state.currSessionId) {
      store.commit('UPDATE_CURR_SESSION_MSGS', {
        type: 'replace',
        idClient,
        msg
      });
    }
  },
  // 更新追加消息，追加一条消息
  PUT_MSG(state, msg) {
    let sessionId = msg.sessionId;
    if (!state.msgs[sessionId]) {
      state.msgs[sessionId] = [];
    }
    // this.updateMsgByIdClient(msg);
    let tempMsgs = state.msgs[sessionId]
    let lastMsgIndex = tempMsgs.length - 1
    if (tempMsgs.length === 0 || msg.time >= tempMsgs[lastMsgIndex].time) {
      tempMsgs.push(msg);
      tempMsgs.push(msg);
      console.log('是否需要重连', state.currSessionReConnect)
      // if (state.currSessionReConnect) {
      //   const topImgVisibile = state.chatConfig.topImgVisibile
      //   if (topImgVisibile) {
      //     const topMsg = Object.assign({}, msg, {
      //       custom: "{\"type\": 2, \"from\" : \"robot\"}",
      //       content: JSON.stringify({
      //         msg: state.chatConfig.topImg
      //       })})
      //     tempMsgs.push(topMsg);
      //   }
      // }
    } else {
      for (let i = lastMsgIndex; i >= 0; i--) {
        let currMsg = tempMsgs[i]
        if (msg.time >= currMsg.time) {
          state.msgs[sessionId].splice(i, 0, msg);
          break;
        }
      }
    }
  },
  // 删除消息列表消息
  deleteMsg(state, msg) {
    let sessionId = msg.sessionId
    let tempMsgs = state.msgs[sessionId]
    if (!tempMsgs || tempMsgs.length === 0) {
      return
    }
    let lastMsgIndex = tempMsgs.length - 1
    for (let i = lastMsgIndex; i >= 0; i--) {
      let currMsg = tempMsgs[i]
      if (msg.idClient === currMsg.idClient) {
        state.msgs[sessionId].splice(i, 1)
        break
      }
    }
  },
  // 替换消息列表消息，如消息撤回
  REPLACE_MSG(state, obj) {
    let {
      sessionId,
      idClient,
      msg
    } = obj
    let tempMsgs = state.msgs[sessionId]
    if (!tempMsgs || tempMsgs.length === 0) {
      return
    }
    let lastMsgIndex = tempMsgs.length - 1
    for (let i = lastMsgIndex; i >= 0; i--) {
      let currMsg = tempMsgs[i]
      console.log('currMsg', idClient, currMsg.idClient, currMsg.text)
      if (idClient === currMsg.idClient) {
        // state.msgs[sessionId].splice(i, 1, msg)
        state.msgs[sessionId].splice(i, 1)
        break
      }
    }
  },
  // 会话是否结束需要重连
  UPDATE_CURR_SESSION_RECONNECT(state, currSessionReConnect) {
    state.currSessionReConnect = currSessionReConnect;
  },
  // 更新当前对话id
  UPDATE_CONVERSATION_ID(state, currSessionConversationId) {
    state.currSessionConversationId = currSessionConversationId;
  },
  // 更新加载状态
  UPDATE_LOADING(state, loadingFlag) {
    state.loading = loadingFlag;
  },
  // 更新加载状态
  UPDATE_EVENT_LOADING(state, loadingFlag) {
    state.eventLoading = loadingFlag;
  },
  SET_WEB_TYPE(state, webtype) {
    state.webtype = webtype;
  },
  // 设置重新建立链接前发送的第一条消息
  SET_RECONNECT_FIRST_MSG(state, obj) {
    state.reconnectFirstMsg = obj;
  },
  // 设置客服正在输入的状态
  SET_CUSTOMER_SERVICE_INPUT_STATUS(state, customerServiceInputStatus) {
    state.customerServiceInputStatus = customerServiceInputStatus;
  },
  // 设置访客发送的失败消息
  SET_SEND_FAIL_MSG_OBJ(state, sendFailMsgObj) {
    state.sendFailMsgObj = sendFailMsgObj;
  },
  // 设置正在输入表单卡片 禁止滚动
  SET_NOT_SCROLL(state, notScroll) {
    state.notScroll = notScroll;
  },
  UPDATE_NET_NIM_STATUS(state, status) {
    state.netNimStatus = status;
  },
  UPDATE_YUN_DUO_ID(state, id) {
    state.yunduoId = id;
  },
  UPDATE_VISITOR_INFO(state, visitSign) {
    state.visitSign = visitSign;
  },
  UPDATE_VISITOR_TOKEN(state, token) {
    state.visitToken = token;
  },
  UPDATE_NIM_OBJECT(state, nim) {
    state.nim = nim;
  },
  UPDATE_HUMAN_NOTICE(state, humanChatMessageNotice) {
    state.humanChatMessageNotice = humanChatMessageNotice;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/im/mutations.js